import React from 'react';
import { DialogActions, Button, Box } from '@mui/material';

interface DialogActionButtonsProps {
    isEditing: boolean;
    isSubmitDisabled: boolean;
    onDelete?: () => void;
    onCancel: () => void;
    onSubmit: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
    isEditing,
    isSubmitDisabled,
    onDelete,
    onCancel,
    onSubmit
}) => {
    return (
        <DialogActions>
            <Box sx={{ flex: 1 }}>
                {isEditing && onDelete && (
                    <Button
                        onClick={onDelete}
                        color="error"
                        variant="outlined"
                    >
                        Delete Procedure
                    </Button>
                )}
            </Box>
            <Button
                onClick={onCancel}
                sx={{
                    color: '#64748b',
                    '&:hover': {
                        backgroundColor: '#f1f5f9',
                        color: '#475569'
                    }
                }}
            >
                Cancel
            </Button>
            <Button
                onClick={onSubmit}
                variant="contained"
                disabled={isSubmitDisabled}
                sx={{
                    backgroundColor: '#162346',
                    '&:hover': {
                        backgroundColor: '#1a2a52'
                    },
                    fontWeight: 600
                }}
            >
                {isEditing ? 'Update Procedure' : 'Add Procedure'}
            </Button>
        </DialogActions>
    );
};
